import { atom } from "jotai";

export const authAtom = atom(false);
